export default __webpack_public_path__ + "static/media/close.8071818a.svg";